<template>
    <el-dialog
        :title="isAdd ? '添加数据' : '查看用户提交数据'"
        width="70%"
        :visible.sync="isShowDialog"
        @close="$emit('hide')">
        <el-form ref="form" :model="values" :rules="rules" v-loading="loading">
            <el-form-item
                v-for="item in scheme"
                :key="item.key"
                :prop="item.key"
                :label="item.label"
                :required="item.required"
                >
                <!-- textarea -->
                <template v-if="item.formType === 'textarea'">
                    <el-input
                        type="textarea"
                        :rows="3"
                        :maxlength="200"
                        :placeholder="'请输入' + item.label"
                        v-model="values[item.key]">
                    </el-input>
                    <p class="textarea-tips" :class="[{ 'max': values[item.key].length >= 200 }]">
                        剩余：{{ values[item.key].length }}/200
                    </p>
                </template>
                <!-- picture -->
                <template v-else-if="item.formType === 'picture'">
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :headers="getUploadHeade()"
                        accept="multipart/form-data"
                        list-type="picture-card"
                        :file-list="values[item.key]"
                        :on-success="handleUploadSuccess"
                        :on-error="handleUploadError"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove">
                            <i class="el-icon-plus"></i>
                    </el-upload>
                    <p class="upload-tips">
                        tips：还需提交图片 <span class="tips-nums">{{ photoLen - values[photoKey].length }}</span> 张
                    </p>
                    <el-dialog :visible.sync="dialogVisible" :modal="false">
                            <img width="100%" :src="dialogImageUrl" custom-class="img-show-dialog" alt="">
                    </el-dialog>
                </template>
                <!-- number -->
                <template v-else-if="item.formType === 'number'">
                    <el-input
                        type="number"
                        :placeholder="'请输入' + item.label"
                        v-model="values[item.key]">
                    </el-input>
                </template>
                <!-- datetime -->
                <template v-else-if="item.formType === 'datetime'">
                    <el-date-picker
                        v-model="values[item.key]"
                        class="form-block-width"
                        type="date"
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </template>
                <!-- datetime -->
                <template v-else-if="item.formType === 'constellations'">
                    <el-select v-model="values[item.key]" :placeholder="'请输入' + item.label" class="form-block-width">
                        <el-option
                            v-for="pick in constellationsPickList"
                            :key="pick.name"
                            :value="pick.name"
                            :label="pick.text">
                        </el-option>
                    </el-select>
                </template>
                <!-- text -->
                <template v-else>
                    <component
                        v-model="values[item.key]"
                        :placeholder="'请输入' + item.label"
                        :is="'el-' + item.formType"
                        :key="item.key"
                        @input="handleFormValueChange(item.key, $event)">
                    </component>
                </template>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    :loading="isSubmitting"
                    :disabled="!hasAdminAuth"
                    @click="onSaveData">保存</el-button>
                <el-button @click.stop="$emit('hide')">取消</el-button>
            </span>
    </el-dialog>
</template>
<script>
import api from '@/api/index.js'
import { getBaseDataSchemeList, constellationsPickList } from '@/utils/scheme.js'
const privateConfig = require('../../../private/config')
import dayjs from 'dayjs'

export default {
    name: 'AddData',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        isAdd: {
            type: Boolean,
            default: false
        },
        folderId: {
            type: [String, Number],
            default: ''
        },
        levels: {
            type: String,
            default: ''
        },
        modifyId: {
            type: [String, Number],
            default: ''
        },
        levelsInfoList: {
            type: Array,
            default: () => ([])
        }
    },
    data () {
        return {
            uploadUrl: privateConfig.api.uploadUrl,
            constellationsPickList: constellationsPickList,
            scheme: {},
            values: {},
            rules: {},
            photoKey: '',
            photoLen: 1, // 需提交的图片数量
            dialogImageUrl: '',
            isShowDialog: this.show,
            dialogVisible: false, // 查看图片
            loading: false,
            isSubmitting: false, // 提交按钮loading
            isUploadErr: false // 上传图片错误提示
        }
    },
    computed: {
        hasAdminAuth () {
            return this.$store.getters.adminAuth
        },
        folderName () {
            const len = this.levelsInfoList.length
            return this.levelsInfoList[len - 1]
        }
    },
    async created () {
        if (!this.isAdd) {
            this.getFiledInfo()
        } else {
            this.getSchemeList()
        }
    },
    methods: {
        // 获取表单配置项
        async getSchemeList () {
            try {
                this.loading = true
                // 取班级文件夹 id，获取该班级的字段配置信息
                const classFolderId = this.levels.split(',').slice(-2)[0]
                const resp = await api.loadScheme({
                    folderId: classFolderId
                })
                if (resp.success) {
                    const showList = resp.data.list.filter(m => m.dataStatus === 1)
                    this.setBaseDataSchemeList(showList)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.loading = false
            }
        },
        // 获取文件详情
        async getFiledInfo () {
            try {
                const data = {
                    batchId: this.modifyId
                }
                const resp = await api.loadFileData(data)
                if (resp.success && resp.data.list.length > 0) {
                    this.setBaseDataSchemeList(resp.data.list)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            }
        },
        // 初始化数据
        setBaseDataSchemeList (list) {
            let userType = ''
            if (this.folderName && this.isAdd) {
                if (this.folderName === '老师') userType = 1
                if (this.folderName === '学生') userType = 2
            }
            const baseConfig = getBaseDataSchemeList(list, userType)
            const { photoKey, photoLen, rules, scheme, values } = baseConfig
            this.scheme = scheme
            this.photoKey = photoKey
            this.photoLen = photoLen
            this.rules = rules
            for (const key in values) {
                // 兼容保存日期非 YYYY/MM/DD 格式
                const targetScheme = scheme.find(item => item.key === key) || {}
                const type = targetScheme.formType
                let val = values[key]
                if (val && type === 'datetime') {
                    try {
                        val = dayjs(val).format('YYYY/MM/DD')
                    } catch (error) {
                        console.log(error)
                    }
                }
                this.$set(this.values, key, val)
            }
        },
        // 保存数据
        async onSaveData () {
            console.log('staty')
            const result = await this.$refs.form.validate()
            if (!result) {
                return
            }
            try {
                this.isSubmitting = true
                let data = Object.keys(this.values).map(key => {
                    let vals = this.values[key]
                    if (Array.isArray(vals)) {
                        vals = vals.map(m => m.id).join(',')
                    }
                    return {
                        folderId: this.folderId,
                        fieldId: key.split('_')[1] * 1,
                        fieldValue: vals
                    }
                })
                let sendMethod = 'addFileData'
                if (!this.isAdd) {
                    sendMethod = 'editFileData'
                    data.forEach(m => {
                        m.batchId = this.modifyId
                    })
                }
                const resp = await api[sendMethod](data)
                if (resp.success) {
                    this.$message.success('保存成功');
                    this.$emit('hide', true)
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.isSubmitting = false
            }
        },
        // 查看图片
        handlePictureCardPreview (file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 删除图片
        handleRemove (file, fileList) {
            this.values[this.photoKey] = fileList
        },
        // 上传成功
        handleUploadSuccess (response, file, fileList) {
            const list = this.values[this.photoKey].slice(0)
            list.push({
                id: response.data[0].id,
                name: response.data[0].fileName,
                url: response.data[0].fileUrl
            })
            this.$set(this.values, this.photoKey, list)
        },
        // 上传失败
        handleUploadError (err) {
            this.$message.error(error.message)
        },
        // 上传文件请求头信息
        getUploadHeade () {
            const token = localStorage.getItem('Authorization');
            return {
                Authorization: token
            }
        },
        // 表单项值改变
        handleFormValueChange (key, value) {
            // s
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
    z-index: 2030 !important;
}
.upload-tips {
    font-size: 14px;
    color: #909399;
    .tips-nums {
        color:#606266
    }
    &.err {
        color: #F56C6C;
        .tips-nums {
            color:#F56C6C;
        }
    }
}
.textarea-tips {
    font-size: 14px;
    color:#909399;
    &.max {
        color:#F56C6C;
    }
}
.form-block-width {
    width: 100%;
}
</style>